import { useLogger } from "@sg-protect/federation-runtime/squide";
import { InternalServerError, MixpanelPropertiesProvider, MixpanelProperty } from "@sg-protect/shell";
import config from "@sg-protect/runtime-config";
import { type ErrorInfo, type PropsWithChildren, useCallback, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";

const ArchiveSource = {
    [MixpanelProperty.Source]: "ShareGate Archives"
};

/**
 * This provider is used for both public and private pages
 */
export function GlobalProviders({ children }: PropsWithChildren) {
    const logger = useLogger();

    useEffect(() => {
        const previousTitle = document.title;
        document.title = "ShareGate | Archives";

        return () => {
            document.title = previousTitle;
        };
    }, []);

    const handleError = useCallback(
        (error: unknown, info: ErrorInfo) => {
            logger
                .withText("[archives] ErrorBoundary caught an error")
                .withError(error as Error)
                .withObject(info)
                .error();
        },
        [logger]
    );

    return (
        <ErrorBoundary fallback={<InternalServerError homeUrl={config.get().home.baseUrl} />} onError={handleError}>
            <MixpanelPropertiesProvider value={ArchiveSource}>{children}</MixpanelPropertiesProvider>
        </ErrorBoundary>
    );
}
